import request from 'utils/request';

export interface NPODto {
    id: number;
    code: string;
    count: number;
    description: string;
    fact_count?: number;
}

export interface TransitionTaskResponse {
    success: boolean;
}

export function syncNPOCount(dep_code: string): Promise<NPODto[]> {
    return request({
        url: `/npo?depCode=${dep_code}`,
        method: 'GET',
    }).then(({ data }) => data as NPODto[]);
}

export function assignNPOCourier(data: {
    region_id: number | string;
    courier_id?: number;
    assigned_npos: NPODto[];
    dep_code: string;
}): Promise<TransitionTaskResponse> {
    return request('/npo/assign', {
        method: 'POST',
        data,
    }).then((res) => res.data as TransitionTaskResponse);
}

export function getNPODetails(order_id: string | number) {
    return request(`/npo/get-detail/${order_id}`, {
        method: 'GET',
    }).then(({ data }) => data);
}
